import { Box, Typography } from '@mui/material';

type ModuleCardProps = {
  icon: string;
  label: string;
  onClick?: () => void;
};

export default function ModuleCard({ icon, label, onClick }: ModuleCardProps) {
  return (
    <Box
      onClick={onClick}
      sx={{
        width: 241,
        height: 153,
        bgcolor: 'primary.main',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        p: 2,
        cursor: 'pointer',
        color: '#fff',
        transition: 'transform 0.2s',
        '&:hover': {
          transform: 'scale(1.03)',
        },
      }}
    >
      <Box sx={{ fontSize: 32 }}>
        <img src={icon} />
      </Box>
      <Typography fontWeight={400} fontSize={18} letterSpacing={1}>
        {label}
      </Typography>
    </Box>
  );
}
